import { Box, BoxProps, Stack } from "@mui/material";
import { ReactElement } from "react";
import { FieldValues } from "react-hook-form";

import Text from "../atoms/Text";

type FormSectionProps<TFieldValues extends FieldValues> = {
  sectionTitle: string;
  sectionDescription?: string;
  direction?: "row" | "column";
  customStyles?: BoxProps["sx"];
  children: ReactElement;
};

const FormSection = <TFieldValues extends FieldValues>({
  sectionTitle,
  sectionDescription,
  direction,
  customStyles,
  children,
}: FormSectionProps<TFieldValues>) => {
  return (
    <Box p={4} bgcolor={"mono.white"} borderRadius={4} sx={customStyles}>
      <Text variant="title_small">{sectionTitle}</Text>
      {sectionDescription && (
        <Text variant="body_large">{sectionDescription}</Text>
      )}
      <Stack
        mt={sectionDescription ? 0 : 2}
        spacing={2}
        direction={direction ?? "column"}
      >
        {children}
      </Stack>
    </Box>
  );
};

export default FormSection;
